"use strict";

// eslint-disable-next-line max-len
const getProductByIdQuery = `query getProduct($id: String!, $market: String, $language: String, $useContentSource: String, $okta: String) {
    productById(
      id: $id
      market: $market
      language: $language
      useContentSource: $useContentSource
      okta: $okta
    ) {
      ...Product
      bundle {
        ...Kit
        __typename
      }
      __typename
    }
  }

  fragment Product on Product {
    id
    slug
    title
    secondaryTitle
    productImages {
      url
      alt
      thumbnail
      __typename
    }
    salesLabel
    salesText
    description
    salesDisclaimer
    variantSelectLabel
    variants {
      ...Variant
      __typename
    }
    features {
      image {
        url
        alt
        thumbnail
        __typename
      }
      subtitle
      features
      backgroundColor
      textColor
      __typename
    }
    productDetails {
      description
      includedItems
      highlights {
        iconUrl
        label
        __typename
      }
      originCountry
      importer
      warnings
      __typename
    }
    benefits {
      benefits
      image {
        url
        alt
        thumbnail
        __typename
      }
      youTubeVideoId
      __typename
    }
    results {
      summary
      results {
        percentage
        text
        __typename
      }
      report {
        url
        text
        __typename
      }
      image {
        url
        alt
        thumbnail
        __typename
      }
      youTubeVideoId
      __typename
    }
    sustainability {
      youTubeVideoId
      image {
        url
        __typename
      }
      description
      highlights {
        image {
          url
          __typename
        }
        description
        __typename
      }
      __typename
    }
    usage {
      steps
      recommendations
      warnings
      additionalText
      image {
        url
        alt
        thumbnail
        __typename
      }
      youTubeVideoId
      markdown
      __typename
    }
    resources {
      title
      url
      image {
        url
        alt
        thumbnail
        __typename
      }
      __typename
    }
    warranty
    faqs {
      question
      answers
      __typename
    }
    ingredients {
      productName
      allIngredients
      otherIngredients
      activeIngredients
      inactiveIngredients
      ingredientDisclaimers
      markdown
      keyIngredients {
        image {
          url
          alt
          thumbnail
          __typename
        }
        name
        description
        __typename
      }
      nutritionInformationImage {
        url
        alt
        __typename
      }
      __typename
    }
    disclaimers
    disclaimerWarnings {
      icon {
        url
        alt
        __typename
      }
      markdown
      __typename
    }
    seoInformation {
      metaDescription
      metaTitle
      canonicalURL
      ogImage {
        url
        alt
        __typename
      }
      __typename
    }
    thirdPartyScripts
    productDataSource {
      source
      webBaseUrl
      apiBaseUrl
      storeId
      __typename
    }
    error {
      name
      errors
      lines
      message
      status
      __typename
    }
    upSellProductIds
    crossProductIds
    __typename
  }

  fragment Variant on Variant {
    sku
    globalId
    slug
    variantLabel
    variantColor
    availableChannels
    availableQuantity
    customerTypes
    maxQuantity
    title
    size
    productImages {
      url
      alt
      thumbnail
      __typename
    }
    salesLabel
    salesText
    description
    salesDisclaimer
    nettoWeight
    features {
      image {
        url
        alt
        thumbnail
        __typename
      }
      subtitle
      features
      backgroundColor
      textColor
      __typename
    }
    productDetails {
      description
      includedItems
      highlights {
        iconUrl
        label
        __typename
      }
      originCountry
      importer
      warnings
      __typename
    }
    benefits {
      benefits
      image {
        url
        alt
        thumbnail
        __typename
      }
      youTubeVideoId
      __typename
    }
    results {
      summary
      results {
        percentage
        text
        __typename
      }
      report {
        url
        text
        __typename
      }
      image {
        url
        alt
        thumbnail
        __typename
      }
      youTubeVideoId
      __typename
    }
    usage {
      steps
      recommendations
      warnings
      additionalText
      image {
        url
        alt
        thumbnail
        __typename
      }
      youTubeVideoId
      markdown
      __typename
    }
    resources {
      title
      url
      image {
        url
        alt
        thumbnail
        __typename
      }
      __typename
    }
    faqs {
      question
      answers
      __typename
    }
    ingredients {
      productName
      allIngredients
      otherIngredients
      activeIngredients
      inactiveIngredients
      ingredientDisclaimers
      markdown
      keyIngredients {
        image {
          url
          alt
          thumbnail
          __typename
        }
        name
        description
        __typename
      }
      nutritionInformationImage {
        url
        alt
        __typename
      }
      __typename
    }
    isExclusive
    price {
      retail
      wholesale
      retailSales
      wholesaleSales
      retailSubscription
      wholesaleSubscription
      currencyCode
      __typename
    }
    totalPrice {
      retail
      wholesale
      retailSales
      wholesaleSales
      retailSubscription
      wholesaleSubscription
      currencyCode
      __typename
    }
    points {
      wholesale {
        cv
        pv
        __typename
      }
      subscription {
        cv
        pv
        __typename
      }
      __typename
    }
    totalPoints {
      wholesale {
        cv
        pv
        __typename
      }
      subscription {
        cv
        pv
        __typename
      }
      __typename
    }
    pricingJson
    availableQuantity
    maxQuantity
    status {
      isBackordered
      backorderedAvailableDate
      status
      __typename
    }
    purchaseTypes {
      buyOnce
      subscription
      __typename
    }
    marketAttributes {
      redeem
      earn
      __typename
    }
    disclaimers
    disclaimerWarnings {
      icon {
        url
        alt
        __typename
      }
      markdown
      __typename
    }
    restrictedMarkets
    matchingVariant
    shadeable
    productType
    primaryBrand
    brandFamily
    __typename
  }

  fragment Kit on Kit {
    id
    type
    price {
      currencyCode
      retail
      wholesale
      retailSales
      wholesaleSales
      retailSubscription
      wholesaleSubscription
      __typename
    }
    totalPrice {
      currencyCode
      retail
      wholesale
      retailSales
      wholesaleSales
      retailSubscription
      wholesaleSubscription
      __typename
    }
    points {
      wholesale {
        cv
        pv
        __typename
      }
      subscription {
        cv
        pv
        __typename
      }
      __typename
    }
    totalPoints {
      wholesale {
        cv
        pv
        __typename
      }
      subscription {
        cv
        pv
        __typename
      }
      __typename
    }
    retailDiscount
    wholesaleDiscount
    pvDiscount
    cvDiscount
    sbDiscount
    grpDiscount
    availableChannels
    customerTypes
    purchaseTypes {
      buyOnce
      subscription
      __typename
    }
    status {
      status
      isBackordered
      backorderedAvailableDate
      __typename
    }
    availableQuantity
    chargeShipping
    dangerousGoods
    excludeFromSearch
    isExclusive
    marketAttributes {
      discount
      redeem
      earn
      __typename
    }
    restrictedMarkets
    scanQualifiedCount
    kitProducts {
      quantity
      isMandatory
      product {
        ...Product
        __typename
      }
      __typename
    }
    __typename
  }`


module.exports = {
  getProductByIdQuery
};